<mat-dialog-content class="p-0">
    <table mat-table [dataSource]="dataSource" matSort>

        <!-- Position Column -->
        <ng-container matColumnDef="event_id">
            <th mat-header-cell *matHeaderCellDef> ID. </th>
            <td mat-cell *matCellDef="let element"> {{element.event_id}} </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="event_name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.event_name}} </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="event_type">
            <th mat-header-cell *matHeaderCellDef> Type </th>
            <td mat-cell *matCellDef="let element"> {{element.event_type}} </td>
        </ng-container>

        <!-- Symbol Column -->
        <!-- <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef> Description </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container> -->

        <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef> Address </th>
            <td mat-cell *matCellDef="let element"> {{element.address}} </td>
        </ng-container>

        <ng-container matColumnDef="from_date">
            <th mat-header-cell *matHeaderCellDef> From Date </th>
            <td mat-cell *matCellDef="let element"> {{element.from_date}} </td>
        </ng-container>

        <ng-container matColumnDef="to_date">
            <th mat-header-cell *matHeaderCellDef> To Date </th>
            <td mat-cell *matCellDef="let element"> {{element.to_date}} </td>
        </ng-container>

        <ng-container matColumnDef="event_logo">
            <th mat-header-cell *matHeaderCellDef> Event Logo </th>
            <td mat-cell *matCellDef="let element">
                <img src="{{element.event_logo}}" style="width: 70px;height: 70px;">
            </td>
        </ng-container>

        <ng-container matColumnDef="event_image">
            <th mat-header-cell *matHeaderCellDef> Event Image </th>
            <td mat-cell *matCellDef="let element">
                <img src="{{element.event_image}}" style="width: 70px;height: 70px;">
            </td>
        </ng-container>

        <ng-container matColumnDef="from_time">
            <th mat-header-cell *matHeaderCellDef> From Time </th>
            <td mat-cell *matCellDef="let element"> {{element.from_time}} </td>
        </ng-container>

        <ng-container matColumnDef="to_time">
            <th mat-header-cell *matHeaderCellDef> To Time </th>
            <td mat-cell *matCellDef="let element"> {{element.to_time}} </td>
        </ng-container>
        <ng-container matColumnDef="is_active">
            <th mat-header-cell *matHeaderCellDef> Is Active? </th>
            <td mat-cell *matCellDef="let element"> {{element.is_active}} </td>
        </ng-container>
        <ng-container matColumnDef="action" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>
                <button mat-raised-button color="primary" style="font-size: 14px;background: green;color: white;
                margin-right: 15px;" (click)="Add_Event()"><mat-icon class="m-0">add</mat-icon>Add</button>
                <button mat-raised-button color="primary" style="font-size: 14px;background: red;color: white;
                margin-right: 15px;" [mat-dialog-close]="false"><mat-icon class="m-0">close</mat-icon></button>
            </th>
            <td mat-cell *matCellDef="let element">
                <button mat-raised-button color="primary" aria-label="Example icon button with a delete icon"
                    style="margin-right: 5px;" (click)="Edit_Event(element.event_id)">
                    <mat-icon class="m-0">edit</mat-icon>
                </button>

                <button mat-raised-button color="warn" aria-label="Example icon button with a delete icon"
                    style="margin-left: 5px;" (click)="DeleteEvent(element.event_id)">
                    <mat-icon class="m-0">delete</mat-icon>
                </button>

            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</mat-dialog-content>